import { Component, HostListener, OnInit } from '@angular/core';
import { GenerateRouteService } from '../../service/generate-route.service';
import { ResponsiveService } from '../../service/responsive.service';
import { TranslationModeEnum } from '../../enum/translation-mode-enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isLandscape: boolean;
  platformLink: string;
  contactLink: string;
  privacyLink: string;
  hiringLink: string;
  tosLink: string;
  cookiesLink: string;
  registerLink: string;
  loginLink: string;
  year = new Date().getFullYear();
  translationModes: typeof TranslationModeEnum = TranslationModeEnum;

  constructor(
    private generateRouteService: GenerateRouteService,
    private responsiveService: ResponsiveService
  ) { }

  ngOnInit() {
    this.isLandscape = this.responsiveService.isLandscape();
    this.loadRouterLinks();
  }

  /**
   * Carga las rutas de manera estática para evitar múltiples ejecuciones
   */
  loadRouterLinks() {
    this.platformLink = this.generateRouteService.generateRoute('Platform');
    this.contactLink = this.generateRouteService.generateRoute('Contact');
    this.privacyLink = this.generateRouteService.generateRoute('Privacy');
    this.hiringLink = this.generateRouteService.generateRoute('Hiring');
    this.tosLink = this.generateRouteService.generateRoute('TermsOfUse');
    this.cookiesLink = this.generateRouteService.generateRoute('Cookies');
    this.registerLink = this.generateRouteService.generateRoute('Register');
    this.loginLink = this.generateRouteService.generateRoute('Login');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isLandscape = this.responsiveService.isLandscape();
  }
}
